import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { PureButton } from '../../basics';
import { ChevronIcon } from '../Icons';
import styles from './SwiffySlider.module.scss';
const Navigation = ({ onSlide }) => {
    const onPrev = () => onSlide(false);
    const onNext = () => onSlide();
    return (_jsxs(_Fragment, { children: [_jsx(PureButton, { "aria-label": "slide prev", className: styles.sliderNav, onClick: onPrev, children: _jsx(ChevronIcon, {}) }), _jsx(PureButton, { "aria-label": "slide next", className: classNames(styles.sliderNav, styles.sliderNavNext), onClick: onNext, children: _jsx(ChevronIcon, {}) })] }));
};
export { Navigation };
